import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        switchLocaleUrl: String,
    };

    onChange(event) {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.name !== 'locale')
            return;
        const locale = input.value;
        const url = new URL(this.switchLocaleUrlValue);
        url.searchParams.set('locale', locale);
        window.location.href = url.toString();
    }
}
